import axios from "../axios";
import qs from "qs";

export const fetchChatData = (showLoadingIndicator = true) => {
	return dispatch => {
		if (showLoadingIndicator) {
			dispatch(fetchChatIsLoading(true));
		}

		dispatch(fetchChatIsError(false));

		axios
			.post("/dmlist")
			.then(response => response.data.data)
			.then(data => {
				if (showLoadingIndicator) {
					dispatch(fetchChatIsLoading(false));
				}
				dispatch(fetchChatDataSuccess(data));
			})
			.catch(err => {
				console.log(err);
				if (showLoadingIndicator) {
					dispatch(fetchChatIsLoading(false));
				}
				dispatch(fetchChatIsError(true, "Connection Error"));
			});
	};
};

export const submitMessage = ({ type, text, dmId, userId }) => {
	return dispatch => {
		dispatch(submitMessageIsLoading(true));

		switch (type) {
			case "ANSWER":
				axios({
					method: "post",
					url: "/dm/answer",
					data: qs.stringify({
						conversation_text: text,
						conversation_type: "text",
						dm_id: dmId
					})
				})
					.then(response => response.data.data)
					.then(data => {
						dispatch(submitMessageIsLoading(false));
						dispatch(fetchConversationData(dmId));
					})
					.catch(err => {
						console.log(err);
						dispatch(submitMessageIsLoading(false));
					});
				break;

			case "ADDNEW":
				axios({
					method: "post",
					url: "/dm/add",
					data: qs.stringify({
						conversation_text: text,
						conversation_type: "text",
						user_id_to: userId
					})
				})
					.then(response => response.data)
					.then(data => {
						dispatch(submitMessageIsLoading(false));
						dispatch(fetchChatData(false));
						dispatch(fetchConversationData(data.dm_id, false));
						dispatch(updateSelectedDmId(data.dm_id));
					})
					.catch(err => {
						console.log(err);
						dispatch(submitMessageIsLoading(false));
					});
				break;
			default:
		}
	};
};

export const submitMessageIsLoading = status => ({
	type: "CHAT_SUBMIT_MSG_IS_LOADING",
	status
});

export const fetchChatDataSuccess = payload => ({
	type: "CHAT_FETCH_SUCCESS",
	payload
});

export const fetchChatIsLoading = status => ({
	type: "CHAT_FETCH_IS_LOADING",
	status
});

export const fetchChatIsError = (status, message) => ({
	type: "CHAT_FETCH_IS_ERROR",
	status,
	message
});

export const fetchConversationData = (dmId, showLoadingIndicator = true) => {
	return dispatch => {
		if (showLoadingIndicator) {
			dispatch(fetchConversationIsLoading(true));
			dispatch(chatRoomOpened(false));
		}

		dispatch(fetchConversationIsError(false));

		axios
			.post(`/dmconversation/${dmId}`)
			.then(response => response.data.data)
			.then(data => {
				if (showLoadingIndicator) {
					dispatch(fetchConversationIsLoading(false));
				}
				dispatch(fetchConversationDataSuccess(data));
				dispatch(chatRoomOpened(true));
			})
			.catch(err => {
				console.log(err);

				if (showLoadingIndicator) {
					dispatch(fetchConversationIsLoading(false));
				}
				dispatch(fetchConversationIsError(true, "Connection Error"));
			});
	};
};

export const fetchConversationDataSuccess = payload => ({
	type: "CHAT_FETCH_CONV_SUCCESS",
	payload
});

export const fetchConversationIsLoading = status => ({
	type: "CHAT_CONV_IS_LOADING",
	status
});

export const fetchConversationIsError = (status, message) => ({
	type: "CHAT_FETCH_CONV_IS_ERROR",
	status,
	message
});

export const chatRoomOpened = status => ({
	type: "CHAT_ROOM_OPEN",
	status
});

export const updateSelectedDmId = dmId => ({
	type: "CHAT_UPDATE_SELECTED_DM_ID",
	dmId
});

export const updateSelectedUserId = userId => ({
	type: "CHAT_UPDATE_SELECTED_USER_ID",
	userId
});

export const submitRemoveDm = dmId => {
	return dispatch => {
		axios({
			method: "post",
			url: "/dm/delete",
			data: qs.stringify({
				dm_id: dmId
			})
		})
			.then(response => response.data.data)
			.then(data => {
				dispatch(fetchChatData(false));
			})
			.catch(err => {
				console.log(err);
			});
	};
};

export const submitRemoveConversation = (conversationId, dmId) => {
	console.log(conversationId, dmId);
	return dispatch => {
		axios({
			method: "post",
			url: "/dm/convdelete",
			data: qs.stringify({
				conversation_id: conversationId
			})
		})
			.then(response => response.data.data)
			.then(data => {
				dispatch(fetchConversationData(dmId, false));
			})
			.catch(err => {
				console.log(err);
			});
	};
};



// WEBPACK FOOTER //
// ./src/actions/chatAction.js